import { SlSelectableDirective } from './../model/directives/sl-selectable.directive';
import { SlFocusDirective } from './../model/directives/sl-focus.directive';
import { SlAriaActiveDescendantDirective } from './../model/directives/sl-aria-activedescendant.directive';
import { SlAriaOwnsDirective } from './../model/directives/sl-aria-owns.directive';
import { NgModule } from '@angular/core';
import { SlIdDirective } from '../model/directives/sl-id.directive';
import { SlForDirective } from '../model/directives/sl-for.directive';
import { SlAriaControlsDirective } from '../model/directives/sl-aria-controls.directive';
import { SlAriaLabelledbyDirective } from '../model/directives/sl-aria-labelledby.directive';
import { SlAriaDescribedbyDirective } from '../model/directives/sl-aria-describedby.directive';


@NgModule({
  declarations: [
    SlIdDirective,
    SlForDirective,
    SlFocusDirective,
    SlAriaControlsDirective,
    SlAriaLabelledbyDirective,
    SlAriaDescribedbyDirective,
    SlAriaOwnsDirective,
    SlAriaActiveDescendantDirective,
    SlSelectableDirective,
  ],

  exports: [
    SlIdDirective,
    SlForDirective,
    SlFocusDirective,
    SlAriaControlsDirective,
    SlAriaLabelledbyDirective,
    SlAriaDescribedbyDirective,
    SlAriaOwnsDirective,
    SlAriaActiveDescendantDirective,
    SlSelectableDirective
  ]
})
export class SlAccessibilityModule { }
